import { CardContainer, Container } from "components";
import React, { useRef } from "react";
import { CKEditor } from "ckeditor4-react";
import Breadcrumb from "components/molecules/Breadcrumb";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { API_URL_cannedResponse } from "constants/api";
import { cannedResponseReducers } from "redux/cannedResponseSlice";
import { postData, putData } from "actions";

const CreateCanned = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputRefs = useRef([]);

  const formik = useFormik({
    initialValues: {
      title: location.state ? location.state.item.title : "",
      message: location.state ? location.state.item.message : "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Name is required"),
      message: Yup.string().required("Message is required"),
    }),
    onSubmit: (values) => {
      const formData = values;
      if (location.state === null) {
        postData(
          API_URL_cannedResponse,
          formData,
          { dispatch, redux: cannedResponseReducers },
          "ADD_CANNEDRESPONSE",
          () => {
            navigate("/tools/cannedresponses");
          }
        );
      } else {
        putData(
          `${API_URL_cannedResponse}${location.state.item.id}/`,
          formData,
          { dispatch, redux: cannedResponseReducers },
          "ADD_CANNEDRESPONSE",
          () => {
            navigate("/tools/cannedresponses");
          }
        );
      }
    },
  });

  // Focus Input validate & submit
  const handleFormSubmit = async (event) => {
    event.preventDefault();
    await formik.validateForm();
    const firstInvalidInputRef = inputRefs.current.find((inputRef) => {
      const fieldName = inputRef.name;
      formik.setFieldTouched(fieldName, true, true);
      return formik.errors[fieldName];
    });
    if (firstInvalidInputRef) {
      firstInvalidInputRef.focus();
    } else {
      formik.handleSubmit();
    }
  };

  const toolbarConfig = {
    extraPlugins: "font,colorbutton,colordialog",
    removePlugins: "about,image",
    skin: "moono",
  };

  return (
    <Container>
      {/* breadcrumb */}
      <Breadcrumb excludedPaths={["tools"]} title={"Form Cannned"} />
      {/* content */}
      <CardContainer
        title={
          location.state ? "Edit Canned Response" : "Create Canned Response"
        }
      >
        <form onSubmit={handleFormSubmit}>
          <div className="m-4">
            <div className="grid grid-cols-1 gap-4">
              <div className="col-span-12 mb-4">
                <label className="block font-bold">
                  Title <span className="text-red-500">*</span>
                </label>
                <input
                  id="title"
                  type="text"
                  name="title"
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  ref={(ref) => (inputRefs.current[0] = ref)}
                  className="w-full p-1 border border-gray-300 dark:text-black focus:border-blue-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                />
                {formik.touched.title && formik.errors.title && (
                  <div className="text-red-500 dark:text-red-300 text-xs">
                    {formik.errors.title}
                  </div>
                )}
              </div>
              <div className="col-span-12">
                <label className="block font-bold">
                  Pesan <span className="text-red-500">*</span>
                </label>
                <div className="w-full">
                  <CKEditor
                    config={toolbarConfig}
                    type="classic"
                    initData={formik.values.message}
                    onChange={(e) =>
                      formik.setFieldValue("message", e.editor.getData())
                    }
                  />
                  {formik.touched.message && formik.errors.message && (
                    <div className="text-red-500 dark:text-red-300 text-xs">
                      {formik.errors.message}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="h-14 w-full flex items-center px-5 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
            <button
              type="submit"
              className="rounded-md text-white py-1.5 w-16 bg-sky-600 hover:bg-sky-800 "
            >
              Submit
            </button>
          </div>
        </form>
      </CardContainer>
    </Container>
  );
};

export default CreateCanned;
